/**
 * send message to Mute/Unmute player or change player mode and parameters
 * iframe.contentWindow.postMessage(
 *     {
 *         command : 'mute',
 *     }, '*'
 * );
 * Listen to messages from the player
 * window.addEventListener('message', event => {
 *     if (event.data.message === 'playerInfo') {
 *         console.log('playerInfo', event.data);
 *     }
 * });
 * @param {*} playerInstance
 */
const messageListener = playerInstance => {
	if (playerInstance) {
		window.addEventListener('message', event => {
			if (event.data.command === 'mute') {
				playerInstance.mute();
			}
			if (event.data.command === 'unmute') {
				playerInstance.unmute();
			}
			if (event.data.command === 'pause') {
				playerInstance.pause();
			}
			if (event.data.command === 'stop') {
				playerInstance.stop();
			}
			if (event.data.command === 'play') {
				playerInstance.play();
			}
			if (event.data.command === 'setPosition') {
				playerInstance.seek(event.data.seconds);
			}
			if (event.data.command === 'getPlayerInfo') {
				const position = playerInstance.getPosition();
				const duration = playerInstance.getDuration();
				// send position back to the parent
				window.parent.postMessage({
					message: 'playerInfo',
					position,
					duration,
				}, '*');
			}

			// switching modes: Only needed in Manager and Arena.
			// External embeds currently don't change the mode or features
			//
			// Desktop: Supports Desktop/iPad down to 1024px
			if (event.data.command === 'mode:Desktop') {
				playerInstance.setMode('desktop');
				playerInstance.setFeature('timeline.minimal', false);
			}
			// Mobile: Supports mobile phones
			if (event.data.command === 'mode:Mobile') {
				playerInstance.setMode('mobile');
				playerInstance.setFeature('timeline.minimal', true);
			}
			// DesktopMinimal: Supports Desktop devices with small browser window (0px - 1024px)
			if (event.data.command === 'mode:DesktopMinimal') {
				playerInstance.setMode('embedded');
				playerInstance.setFeature('timeline.minimal', true);
			}

			// set features on embed, see resources/assets/videotools/js/initApp.js -> featureMutations for all available features
			if (event.data.command === 'setFeature') {
				playerInstance.setFeature(event.data.feature, event.data.value);
			}
		});
	}
};

export const initEmbedViewMode = async(initViewMode) => {
	const params = new URLSearchParams(window.location.search);
	const mode = 'embedded';
	const event = arenaEmbedPlayerConfig.event ?? null;

	const { playerType } = arenaEmbedPlayerConfig;
	const password = params.get('password') ? atob(params.get('password')) : null;

	// without params the features default for the embed mode
	const features = {
		sharing:  params.has('enableSharing'),
		timeline: {
			enable:   !params.has('disableTimeline'),
			minimal:  !params.has('enableMaximisedTimeline'),
			showTags: params.getAll('showTag'),
		},
		player: {
			autoplay:               params.has('enableAutoplay'),
			contentInfoEnabled:     !params.has('disableContentInfo'),
			logo:                   window.isAtv ? false : !params.has('disableLogo'),
			pause:                  !params.has('disablePause'),
			seek:                   !params.has('disableSeek'),
			forceDisableChromeCast: params.has('disableChromeCast'),
			stop:                   params.has('enableStop'),
			time:                   !params.has('disableTime'),
			playbackSpeedEnabled:   !params.has('disablePlaybackSpeed'),
			qualitySettingsEnabled: !params.has('disableQualitySettings'),
			forceOverlayVisible:    params.has('forceOverlayVisible'),
		},
		loopedBackgroundMode: params.has('loopedBackgroundMode'),
		autostartCouchMode:   params.has('autostartCouchMode'),
		disableProfile:       params.has('disableProfile'),
		disableAds:           params.has('disableAds'),
	};

	const playerInstance = await initViewMode({
		mode,
		event,
		playerType,
		password,
		features,
	});

	messageListener(playerInstance);
};
